<template>
  <div id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view />
    </keep-alive>
    <keep-alive v-else>
      <router-view :key="$route.path + Date.now()" />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
.reserve-list {
  z-index: -1;
}
/* .container {
  width: 10rem;
  margin: 0 auto;
} */
div,
p,
span {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  /* font-size: 0.386473rem; */
}
@font-face {
  font-family: newfontnormal;
  src: url("//pic-cdn.bigdatajy.com/wenming/static/font/FZBIAOYSK.ttf");
}
</style>



// WEBPACK FOOTER //
// src/App.vue